namespace Portico.Services {

    import pme = Portico.Models.Enterprise;
	import psga = apigateway.client;
	import psge = apigateway.enums;
	import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IAccountService {
		activateUser(userName: string, activate: boolean): angular.IPromise<number>;
		create(programId: number, account?: pme.Account): angular.IPromise<pme.Account>;
		createFromCase(programId: number, caze: psgm.GetCaseResponseModel): angular.IPromise<pme.Account>;
		getPrescribers(): angular.IPromise<pme.Prescriber[]>;
		getSites(): angular.IPromise<pme.Site[]>;
		getTasks(typeId: number, accountId?: number): angular.IPromise<pme.Task[]>;
		getUsers(): angular.IPromise<pme.User[]>;
        removePrescriber(prescriberId: number): angular.IPromise<boolean>;
        removeSite(siteId: number): angular.IPromise<boolean>;
		savePrescriber(prescriber: pme.Prescriber): angular.IPromise<number>;
		saveSite(site: pme.Site): angular.IPromise<number>;
		saveTask(task: pme.Task): angular.IPromise<pme.Task>;
		saveUser(user: pme.User): angular.IPromise<boolean>;
		saveUserRole(userName: string, role: string): angular.IPromise<boolean>;
		updateAccount(account: pme.Account, programId?: string): angular.IPromise<psgm.IUpdateAccountModel>;
    }

    @Service('app', 'accountService')
	@Inject('$q', 'EdgeAccountApi')
    export class AccountService implements IAccountService {
        constructor(
            private $q: angular.IQService,
			private edgeAccountApi: psga.EdgeAccountApi,
        ) { }

		activateUser(userName: string, activate: boolean): angular.IPromise<number> {
			const request = {
				userName: userName,
				activate: activate
			};

			return this.$q.when(this.edgeAccountApi.accountActivateUser(request).then((response) => {
				return response.data.data;
			}));
		}

		create(programId: number, account: pme.Account = null): angular.IPromise<pme.Account> {
			return this.$q.when(new pme.Account(account || <pme.IAccount>{ programId: programId }));
		}

		createFromCase(programId: number, caze: psgm.GetCaseResponseModel): angular.IPromise<pme.Account> {
			return null; // this.$q.when(new pme.Account(account || <pme.IAccount>{ programId: programId }));
		}

		getPrescribers(): angular.IPromise<pme.Prescriber[]> {
			return this.$q.when(this.edgeAccountApi.accountGetPrescribers({}).then((response) => {
				return _.map(response.data.data, (s) => {
					return new pme.Prescriber(s);
				});
			}));
		}

		getSites(): angular.IPromise<pme.Site[]> {
			return this.$q.when(this.edgeAccountApi.accountGetSites({}).then((response) => {
				return _.map(response.data.data, (s) => {
					s.businessEndTime = <moment.Moment><unknown>s.businessEndTime?.toDate();
					s.businessStartTime = <moment.Moment><unknown>s.businessStartTime?.toDate();
					return new pme.Site(s);
				});
			}));
		}

		getTasks(typeId: number, accountId: number = null): angular.IPromise<pme.Task[]> {
			return this.$q.when(this.edgeAccountApi.accountGetTasks({ typeId: typeId, accountId: accountId }).then((response) => {
				const tasks = [];

				for (const task of response.data.data) {
					task.completionDate = <moment.Moment><unknown>task.completionDate?.toDate();
					task.createdDate = <moment.Moment><unknown>task.createdDate?.toDate();
					task.dueDate = <moment.Moment><unknown>task.dueDate?.toDate();
					task.updatedDate = <moment.Moment><unknown>task.updatedDate?.toDate();
					tasks.push(new pme.Task(task));
				}

				return tasks;
			}));
		}

		getUsers(): angular.IPromise<pme.User[]> {
			return this.$q.when(this.edgeAccountApi.accountGetUsers({}).then((response) => {
				const users = _.map(response.data.data, (u) => {
					return new pme.User(u);
				});
				return users;
			}));
		}

        removePrescriber(prescriberId: number){
            var requestModel: psgm.RemovePrescriberRequestModel = {
                prescriberId
            }
			return this.$q.when(this.edgeAccountApi.accountRemovePrescriber(requestModel).then(response => {
				return response.data.data;
            }));
        }

        removeSite(siteId: number){
            var requestModel: psgm.RemoveSiteRequestModel = {
                siteId
            }
			return this.$q.when(this.edgeAccountApi.accountRemoveSite(requestModel).then(response => {
				return response.data.data;
            }));
        }

		savePrescriber(prescriber: pme.Prescriber): angular.IPromise<number> {
			return this.$q.when(this.edgeAccountApi.accountSavePrescriber(prescriber.mapToPrescriberUpsearchModel()).then((response) => {
				return response.data.data;
			}));
		}

		saveSite(site: pme.Site): angular.IPromise<number> {
			return this.$q.when(this.$q.when(this.edgeAccountApi.accountSaveSite(site.mapToSiteUpsearchModel()).then((response) => {
				return response.data.data;
			})));
		}

		saveTask(task: pme.Task): angular.IPromise<pme.Task> {
			const now = new Date();
			const request = {
				accountId: _.get(task, 'accountId', null),
				caseId: _.get(task, 'caseId', null),
				assignedUserId: _.get(task, 'assignedUserId', null),
				dueDate: moment(_.get(task, 'dueDate', now)),
				completionDate: moment(_.get(task, 'completionDate', null)),
				isCompleted: _.get(task, 'isCompleted', false),
				resolution: _.get(task, 'resolution', ''),
				documentId: _.get(task, 'documentId', null),
				typeId: _.toNumber(_.get(task, 'typeId', null)),
				subject: _.get(task, 'subject', ''),
				body: _.get(task, 'body', '')
			};

			return this.$q.when(this.edgeAccountApi.accountSaveTask(request).then((response) => {
				const task = new pme.Task(request);
				task.id = response.data.data;
				task.createdDate = now;
				return task;
			}));
		}

		saveUser(user: pme.User): angular.IPromise<boolean> {
			return this.$q.when(this.edgeAccountApi.accountSaveUser(user).then((response) => {
				return true;
			}));
		}

		saveUserRole(userName: string, role: string): angular.IPromise<boolean> {
			const request = <psgm.ISaveUserRoleRequestModel> {
				userName: userName,
				role: role
			};
			return this.$q.when(this.edgeAccountApi.accountSaveUserRole(request).then((response) => {
				return true;
			}));
		}

		updateAccount(account: pme.Account, programId?: string) {
			const {
				type,
				status,
				partyId,
				securePartyId,
				assignedUser,
				payorRelationships,
				prescriberRelationships,
				siteRelationships,
				pharmacyRelationships,
				documentRelationships,
				notes,
				tasks,
				voiceMailOptIns,
				assignmentOfBenefitFlag,
				isIneligibleForMailInClaims,
				allowAutoReenroll,
			} = account;
			const payors: psgm.AccountPayorRelationModel[] = payorRelationships.map((rel) => ({
				roleType: rel.role as unknown as psge.AccountRoleType,
				accountRelations: [{
					coverageOrder: rel.order,
					relatedId: rel.payorId,
					isPrimary: rel.isPrimary,
				}]
			}));
			const prescribers: psgm.AccountRelationModel[] = prescriberRelationships.map((rel) =>({
				relatedId: rel.prescriberId,
				isPrimary: rel.isPrimary,
			}));
			const sites: psgm.AccountRelationModel[] = siteRelationships.map((rel) => ({
				relatedId: rel.siteId,
				isPrimary: rel.isPrimary,
			}))
			const pharmacies: psgm.AccountRelationModel[] = pharmacyRelationships.map((rel) => ({
				relatedId: rel.pharmacyId,
				isPrimary: rel.isPrimary,
			}));
			const documents: psgm.AccountDocumentRelationshipModel[] = documentRelationships.map((rel) => ({
				documentId: rel.documentId,
				comment: rel.comment,
			}))
			const accountSaveModel: psgm.AccountSaveModel = {
				accountType: psge.AccountType[type],
				accountStatus: psge.AccountStatus[status],
				partyId,
				securePartyId,
				assignedUser,
				payors,
				prescribers,
				sites,
				pharmacies,
				documents,
				notes,
				tasks,
				voicemailOptInStatus: voiceMailOptIns,
				assignmentOfBenefitFlag,
				isIneligibleForMailInClaims,
				allowAutoReenroll,
			}
			return this.$q.when(this.edgeAccountApi.accountUpdateAccount(accountSaveModel, programId).then((response) => response.data.data));
		}
    }
}